<template>
  <div class="VacationDetailsListWeb">
    <v-data-table
      dense
      :disable-sort="true"
      :headers="headers"
      hide-default-footer
      disable-pagination
      :items="list"
      item-key="MessageId"
    />
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("PeriodWorkDetails.tabs.detailsMorakhasi.vacationName"),
          value: "Name",
        },
        {
          text: this.$t("PeriodWorkDetails.tabs.detailsMorakhasi.AmountYear"),
          value: "AmountYear",
        },
        {
          text: this.$t("PeriodWorkDetails.tabs.detailsMorakhasi.DaysYear"),
          value: "DaysYear",
        },
        {
          text: this.$t("PeriodWorkDetails.tabs.detailsMorakhasi.AmountMonth"),
          value: "AmountMonth",
        },
        {
          text: this.$t("PeriodWorkDetails.tabs.detailsMorakhasi.DaysMonth"),
          value: "DaysMonth",
        },
      ],
    };
  },
  methods: {},
};
</script>

<style>
</style>